import { Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useCreateListDataMutation } from '../../api/apiSlice';
import FormikButton from '../../components/formik/FormikButton';
import FormikInput from '../../components/formik/FormikInput';
import Form from '../../components/utilities/Form';
import { deviceName } from '../../utils/config';
import errorSnackbar from '../../utils/errorSnackbar';

const validate = Yup.object().shape({
    code: Yup.string().required().label('Confirmation Code'),
    password: Yup.string().required().label('Password'),
    password_confirmation: Yup.string().oneOf(
        [Yup.ref('password'), null],
        'Passwords must match'
    ),
});

export default function CreatePassword({ phoneNumber, setCodeSent }) {
    const [resendSeconds, setResendSeconds] = useState(30);

    const navigate = useNavigate();
    const { enqueueSnackbar } = useSnackbar();
    const [requestResetCode] = useCreateListDataMutation();
    const [createPassword, { isLoading }] = useCreateListDataMutation();

    const waitUntilResend = useCallback(() => {
        const countDown = setInterval(() => {
            if (resendSeconds > 1) {
                clearInterval(countDown);
                setResendSeconds(resendSeconds - 1);
            }
        }, 1000);
    }, [resendSeconds]);

    useEffect(() => {
        waitUntilResend();
    }, [waitUntilResend]);

    return (
        <Form
            validationSchema={validate}
            initialValues={{
                code: '',
                password: '',
                password_confirmation: '',
            }}
            onSubmit={async (vals) => {
                const { data, error } = await createPassword({
                    list: '/reset',
                    body: {
                        ...vals,
                        phone: phoneNumber,
                        device_name: deviceName,
                    },
                });

                errorSnackbar(error, enqueueSnackbar);

                if (data) {
                    enqueueSnackbar('Password set successfully');
                    navigate(-1);
                }
            }}
        >
            <Typography variant="h6">{phoneNumber}</Typography>
            <Typography
                onClick={() => setCodeSent(false)}
                variant="h6"
                color="primary"
            >
                Not your phone number?
            </Typography>
            <FormikInput name="code" placeholder="Confirmation Code" />
            <FormikInput
                name="password"
                placeholder="New Password"
                type="password"
            />
            <FormikInput
                name="password_confirmation"
                placeholder="Confirm New Password"
                type="password"
            />
            <FormikButton loading={isLoading} variant="contained">
                Reset Password
            </FormikButton>
            <div style={{ marginTop: 20 }}>
                {!(resendSeconds > 1) ? (
                    <>
                        <Typography>Didn&apos;t get the code? </Typography>
                        <Typography
                            onClick={async () => {
                                const { error, data } = await requestResetCode({
                                    list: '/reset/request',
                                    body: { phone: phoneNumber },
                                });

                                errorSnackbar(error, enqueueSnackbar);

                                if (data) {
                                    enqueueSnackbar('Code resent successfully');
                                    setResendSeconds(30);
                                }
                            }}
                            color="primary"
                        >
                            Send Again.
                        </Typography>
                    </>
                ) : (
                    <Typography>{resendSeconds}</Typography>
                )}
            </div>
        </Form>
    );
}
